module.exports = __webpack_public_path__ + "img/DSC_0180 teatro 2_thumb.040904cd.jpg";